<!--
 * @Author: wangzhu
 * @LastEditors: wangzhu
 * @Date: 2020-07-30 11:31:55
 * @LastEditTime: 2020-08-10 21:41:31
 * @Description: File description
-->
<template>
  <el-dialog
    title="请完成安全验证"
    :visible.sync="captchaVisible"
    :append-to-body="true"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    width="390px"
    top="40vh"
    class="no-captcha-wrap"
  >
    <div id="captcha"></div>
  </el-dialog>
</template>
<script>
import authApi from '@/services/auth'
export default {
  name: 'NoCaptcha',
  data () {
    return {
      nc: null,
      captchaVisible: false,
      params: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      window.NVC_Opt = {
        appkey: 'FFFF0N00000000007F27',
        scene: 'nvc_login',
        isH5: false,
        popUp: false,
        renderTo: `#captcha`,
        nvcCallback: (data) => {
          console.log('二次回调成功', data)
          let params = JSON.parse(localStorage.getItem('params'))
          this.handleCaptcha(params, data)
          this.captchaVisible = false
          // 其中，data为getNVCVal()函数的值，该函数为二次验证滑动或者刮刮卡通过后的回调函数。
          // data与业务请求一同上传，由后端请求AnalyzeNvc接口并返回100或者900。
        },
        trans: {},
        language: 'cn',
        // 当唤醒滑动验证作为二次验证，组件宽度
        customWidth: '100%'
      }
      // 加载js文件
      const s = document.createElement('script')
      s.type = 'text/javascript'
      s.src = '//g.alicdn.com/sd/nvc/1.1.112/guide.js?t=20200808'
      document.body.appendChild(s)
    },
    handleCaptcha (params, da) {
      localStorage.setItem('params', JSON.stringify(params))
      return new Promise((resolve, reject) => {
        let data = da || getNVCVal() // eslint-disable-line
        let queryParams = Object.assign({ data, captcha: 1 }, params) // : getNVCVal()
        authApi.fetchSMSCode(queryParams).then(res => {
          if (res.status_code === 200) {
            if (['400', '600'].includes(res.data.BizCode)) {
              this.captchaVisible = true
              getNC().then(function () { // eslint-disable-line
                _nvc_nc.upLang('cn', { // eslint-disable-line
                  _startTEXT: '向右滑动验证',
                  _yesTEXT: '验证成功',
                  _error300: '未通过安全验证，请重试',
                  _errorNetwork: '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
                })
                _nvc_nc.reset()// eslint-disable-line
              })
            } else if (res.data.BizCode === '700') {
              getLC() // eslint-disable-line
            } else if (res.data.BizCode === '100' || res.data.BizCode === '200') {
              // 注册成功
              nvcReset() // eslint-disable-line
              resolve(res)
            } else if (res.data.BizCode === '800' || res.data.BizCode === '900') {
              // 直接拦截
              nvcReset() // eslint-disable-line
            } else {
              resolve(res)
              this.captchaVisible = false
              this.$emit('timeDown')
            }
          } else {
            // this.captchaVisible = false
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.no-captcha-wrap {
  font-family: PingFangSC-Regular, PingFang SC;
  .el-dialog__header {
    font-size: 16px;
  }
  .el-dialog {
    border-radius: 10px;
  }
  /deep/ .el-dialog__body {
    padding: 25px 20px 40px 20px;
  }
  /deep/ .nc-container .nc_scale {
    width: 100%;
    height: 56px;
    line-height: 56px;
    background: #f9fbfc;
    border-radius: 3px;
  }
  /deep/ .nc-container .nc_scale span {
    background: #5280fb;
    width: 56px;
    height: 56px;
    line-height: 56px !important;
    border: none !important;
  }
  /deep/ .nc_scale .scale_text {
    color: #626d7b;
    font-size: 16px !important;
    line-height: 56px !important;
    border: 1px solid rgba(238, 238, 238, 1);
  }
  /deep/ .nc-container .nc_scale .btn_slide {
    color: #fff;
  }
  /deep/ .nc_iconfont {
    font-size: 24px;
  }
  /deep/ .nc_scale div.nc_bg {
    background: #e7eeff;
    border: 1px solid rgba(82, 128, 251, 1);
  }
  /deep/ .nc-container #nc_1_wrapper {
    width: 100%;
  }
  /deep/ .nc-container .nc_scale .scale_text2 {
    color: #66e1b5;
  }
  /deep/ .nc-container .nc_scale .btn_ok {
    background: #43d7ad;
    color: #fff;
  }
  /deep/ .nc-container .errloading {
    height: 56px;
    line-height: 44px;
    padding-left: 15px;
    width: 100%;
    overflow: hidden;
  }
  /deep/ .nc-container .errloading .icon_warn {
    color: #ff874d;
  }
  /deep/ .nc-container .nc-lang-cnt {
    color: #626d7b;
    font-size: 14px;
    width: 300px;
    display: inline-block;
  }
}
</style>
